import React from 'react';
import Skeleton from 'react-loading-skeleton';

const RoleDetailsSkeleton = () => {
  const styles = {
    top: {
      marginTop: 30,
      marginBottom: 30,
      marginRight: 30
    },
    item: {
      borderRadius: 30
    }
  };
  return (
    <>
      <Skeleton count={1} width={300} height={328} borderRadius={15} style={styles.top} />
      <Skeleton count={1} width={930} height={637} borderRadius={15} style={styles.top} />
    </>
  );
};

export default RoleDetailsSkeleton;
